import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/favorites/user.ts
import { Exception } from "@wbk/logger";
var getUserFavorites = (props) => __async(void 0, null, function* () {
  try {
    const params = new URLSearchParams();
    if (props == null ? void 0 : props.page)
      params.set("page", props.page.toString());
    if (props == null ? void 0 : props.type)
      params.set("type", props.type);
    const res = yield fetchClient({
      url: `/user-favorites?${params.toString()}`
    });
    return res.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getUserFavoritesException"
    });
  }
});

export {
  getUserFavorites
};
//# sourceMappingURL=chunk-CUQKYHNP.mjs.map